function createImagePreprocessorWorker() {
  return new Worker(new URL('./imagePreprocessor.worker.js', import.meta.url));
}

function createRawImageWorker() {
  return new Worker(new URL('./pages/worker.js', import.meta.url));
}

export { createImagePreprocessorWorker, createRawImageWorker };
